import { AIChipButton } from "@similarweb/ai-kit";

import { translate } from "app/filters/i18nFilter";
import { AI_CHIPS_TITLE } from "app/pages/activation/components/SetupModal/CompetitorsStep/AIChips/texts";

import * as SC from "./styles";

type AIChipsSchema = {
    onClick: (chip: string) => void;
    isDisabled: boolean;
    isAISuggestionLoading: boolean;
    suggestedPrompts: string[];
};

export const AIChips = ({ onClick, isDisabled, isAISuggestionLoading, suggestedPrompts }: AIChipsSchema) => {
    return (
        <SC.ChipsWrapper>
            <SC.AIInputTitle>{translate(AI_CHIPS_TITLE)}:</SC.AIInputTitle>

            {suggestedPrompts.map((chip) => (
                <AIChipButton
                    key={chip}
                    onClick={() => onClick(chip)}
                    label={chip}
                    variant="soft"
                    withShadow
                    disabled={isDisabled}
                    isLoading={isAISuggestionLoading}
                />
            ))}
        </SC.ChipsWrapper>
    );
};
